export const createWrapAudioBufferSourceNodeStopMethodNullifiedBuffer = (overwriteAccessors) => {
    return (nativeAudioBufferSourceNode, nativeContext) => {
        const nullifiedBuffer = nativeContext.createBuffer(1, 1, nativeContext.sampleRate);
        if (nativeAudioBufferSourceNode.buffer === null) {
            nativeAudioBufferSourceNode.buffer = nullifiedBuffer;
        }
        overwriteAccessors(nativeAudioBufferSourceNode, 'buffer', (get) => () => {
            const value = get.call(nativeAudioBufferSourceNode);
            return (value === nullifiedBuffer) ? null : value;
        }, (set) => (value) => {
            return set.call(nativeAudioBufferSourceNode, (value === null) ? nullifiedBuffer : value);
        });
    };
};
//# sourceMappingURL=/build/es2018/factories/wrap-audio-buffer-source-node-stop-method-nullified-buffer.js.map